import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=da524714&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=da524714&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da524714",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da524714')) {
      api.createRecord('da524714', component.options)
    } else {
      api.reload('da524714', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=da524714&scoped=true", function () {
      api.rerender('da524714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/decorationPage/library/modules/Hotspot/Form.vue"
export default component.exports